<div class="story-item">
  <div class="story-item__year fs-1">{{ item.year }}</div>
  <div class="story-item__content">
    <h3 class="story-item__title fs-4">{{ item.title }}</h3>
    <p class="story-item__description mb-0">{{ item.description }}</p>
  </div>
</div>
